// import React, { useState } from 'react';
// Import your MixedWidget10C component
// import { MixedWidget10C } from './path/to/your/MixedWidget10C';
// import { MixedWidget10C } from '../../../_metronic/partials/widgets/mixed/MixedWidget10C';
import React, { useState } from 'react';
import { MixedWidget100 } from '../../../_metronic/partials/widgets/mixed/MixedWidget100';
// Import your MixedWidget10C component
// import { MixedWidget10C } from './path/to/your/MixedWidget10C';

interface WasteItem {
    id: string;
    item: string;
    category: string;
    quantity: number;
    yesterday: number;
    lastWeek: number;
    lastMonth: number;
    graphData: number[];
}

interface WasteDashboardProps {
    analyticsData?: any;
}

const WasteDashboard: React.FC<WasteDashboardProps> = ({ analyticsData }) => {
    const [activeTab, setActiveTab] = useState<'Collection' | 'Processing' | 'Dispatch'>('Collection');
    const [isLoading, setIsLoading] = useState(false);
    // const data = React.useMemo(() => {
    //     if (!analyticsData?.data?.[0]) return [];

    //     let sourceData;
    //     switch (activeTab) {
    //         case 'Collection':
    //             sourceData = analyticsData.data[0].itemCollectionDetails;
    //             break;
    //         case 'Processing':
    //             sourceData = analyticsData.data[0].itemProductionDetails;
    //             break;
    //         case 'Dispatch':
    //             sourceData = analyticsData.data[0].itemDispatchDetails;
    //             break;
    //         default:
    //             sourceData = [];
    //     }

    //     if (!sourceData) return [];

    //     return sourceData.map((item: any) => ({
    //         id: item.itemId,
    //         item: item.itemName,
    //         category: item.categoryName,
    //         quantity: item.totalQuantity,
    //         yesterday: item.yesterdayQuantity || 0,
    //         lastWeek: item.weekQuantity || 0,
    //         lastMonth: item.monthQuantity || 0,
    //         graphData: item.monthWiseData,
    //         itemIcon: item.itemIcon
    //     }));
    // }, [analyticsData, activeTab]);

    const data = React.useMemo(() => {
        if (!analyticsData?.data?.[0]) return [];

        let sourceData;
        switch (activeTab) {
            case 'Collection':
                sourceData = analyticsData.data[0].itemCollectionDetails;
                break;
            case 'Processing':
                sourceData = analyticsData.data[0].itemProductionDetails;
                break;
            case 'Dispatch':
                sourceData = analyticsData.data[0].itemDispatchDetails;
                break;
            default:
                sourceData = [];
        }
        if (!sourceData) return [];

        return sourceData.slice(0, 10).map((item: any) => ({
            id: item.itemId,
            item: item.itemName,
            category: item.categoryName,
            quantity: item.totalQuantity,
            yesterday: item.yesterdayQuantity || 0,
            lastWeek: item.weekQuantity || 0,
            lastMonth: item.monthQuantity || 0,
            graphData: item.monthWiseData,
            itemIcon: item.itemIcon,
            dayPercentageHike: item.dayPercentageHike,
            weeklyPercentageHike: item.weeklyPercentageHike,
            monthlyPercentageHike: item.monthlyPercentageHike
        }));
    }, [analyticsData, activeTab]);

    const getPercentageStyle = (percentage: number | null): React.CSSProperties | undefined => {
        if (percentage === null || percentage === undefined) return undefined;

        const isPositive = percentage >= 0;
        return {
            backgroundColor: isPositive ? '#dfffea' : '#ffeef3',
            color: isPositive ? '#2bca5f' : '#f8285a',
            // padding: '2px 6px',
            // borderRadius: '6px',
            // fontSize: '0.75rem',
            fontWeight: '500',
            // marginTop: '4px',
            // display: 'inline-block',

            //  backgroundColor: '#f5f5f5',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '0.875rem',
            // color: '#666',
            marginTop: '4px',
            display: 'inline-block'
        };
    };

    const dashboardStyles = {
        container: {
            width: '100%',
            background: 'white',
            borderRadius: '8px',
            overflow: 'hidden' as const,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", Roboto, "Inter Neue", Arial, sans-serif',
            padding: '16px',
            marginBottom: '12px'
        },
        title: {
            fontSize: '1.35rem',
            fontWeight: 'bold',
            marginBottom: '20px',
            color: '#000000'
        },
        tabNavigation: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            background: '#ffffff',
            borderBottom: '1px solid #f0f0f0',
            padding: '16px 20px',
            gap: '8px'
        },
        tabButton: (isActive: boolean) => ({
            padding: '8px 24px',
            border: `2px solid ${isActive ? '#000000' : '#000000'}`,
            background: isActive ? '#000000' : 'transparent',
            color: isActive ? '#ffffff' : '#000000',
            fontSize: '14px',
            fontWeight: '600' as const,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            borderRadius: '25px',
            minWidth: '120px',
            textAlign: 'center' as const,
            outline: 'none',
            boxShadow: isActive ? '0 4px 12px rgba(0, 0, 0, 0.3)' : 'none',
            transform: isActive ? 'translateY(-1px)' : 'translateY(0px)'
        }),
        tableContainer: {
            overflowX: 'auto' as const,
            marginBottom: '20px'
        },
        table: {
            minWidth: '100%',
            borderCollapse: 'separate' as const,
            borderSpacing: '15px'
        },
        thead: {
            background: 'transparent'
        },
        th: {
            padding: '8px 16px',
            textAlign: 'left' as const,
            fontWeight: 'bold' as const,
            color: '#9ba1b7',
            fontSize: '1.075rem',
            whiteSpace: 'nowrap' as const,
            border: 'none'
        },
        thGraph: {
            padding: '8px 16px',
            textAlign: 'left' as const,
            fontWeight: 'bold' as const,
            color: '#9ba1b7',
            fontSize: '1.075rem',
            whiteSpace: 'nowrap' as const,
            border: 'none',
            width: '80px'
        },
        td: {
            padding: '8px 16px',
            color: '#000000',
            fontSize: '1.075rem',
            verticalAlign: 'middle' as const,
            whiteSpace: 'nowrap' as const,
            borderBottom: '1px solid #f9f9f9'
        },
        tdGraph: {
            padding: '8px 16px',
            color: '#000000',
            fontSize: '1.075rem',
            verticalAlign: 'middle' as const,
            whiteSpace: 'nowrap' as const,
            borderBottom: '1px solid #f9f9f9',
            width: '80px'
        },
        itemCell: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
        },
        row: {
            transition: 'background-color 0.2s ease',
            cursor: 'pointer'
        }
    };


    const handleTabClick = (tab: 'Collection' | 'Processing' | 'Dispatch') => {
        setActiveTab(tab);
    };

    return (
        <div style={dashboardStyles.container}>
            {/* Tab Navigation */}
            {/* Add heading above the tab navigation */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 20px',
                borderBottom: '1px solid #f0f0f0'
            }}>
                <h3 className='card-title'>
                    <span style={{
                        fontWeight: 600,
                        fontSize: '1.55rem',
                        marginBottom: '0.25rem',
                        display: 'block'
                    }}>
                        Trending SKUs
                    </span>
                </h3>
                <div style={{ display: 'flex', gap: '8px' }}>
                    {(['Collection', 'Processing', 'Dispatch'] as const).map((tab) => (
                        <button
                            key={tab}
                            style={dashboardStyles.tabButton(activeTab === tab)}
                            onClick={() => handleTabClick(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>
            {/* Table */}
            <div style={dashboardStyles.tableContainer}>
                <table style={dashboardStyles.table}>
                    <thead style={dashboardStyles.thead} className="custom-waste-dashboard-thead">
                        <tr>
                            <th style={dashboardStyles.th}>Icon</th>
                            <th style={dashboardStyles.th}>Item</th>
                            <th style={dashboardStyles.th}>Category</th>
                            <th style={dashboardStyles.th}>Quantity</th>
                            <th style={dashboardStyles.th}>Yesterday</th>
                            <th style={dashboardStyles.th}>This Week</th>
                            <th style={dashboardStyles.th}>This Month</th>
                            <th style={dashboardStyles.th}>Trend</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item) => (
                            <tr
                                key={item.id}
                                style={dashboardStyles.row}
                            >
                                <td style={dashboardStyles.td}>
                                    <div style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '50%',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: '#f5f5f5'
                                    }}>
                                        <img
                                            src={item.itemIcon}
                                            alt={item.item}
                                            style={{
                                                width: '150%',
                                                height: '150%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </div>
                                </td>
                                <td style={dashboardStyles.td}>
                                    <div style={dashboardStyles.itemCell}>
                                        <span>{item.item}</span>
                                    </div>
                                </td>
                                <td style={dashboardStyles.td}>{item.category}</td>
                                <td style={dashboardStyles.td}>{item.quantity.toLocaleString()}</td>
                                {/* <td style={dashboardStyles.td}>{item.yesterday.toLocaleString()}</td> */}
                                <td style={dashboardStyles.td}>
                                    <div>
                                        <div>{item.yesterday.toLocaleString()}</div>
                                        {item.dayPercentageHike !== null && (
                                            <div style={getPercentageStyle(item.dayPercentageHike)!}>
                                                {item.dayPercentageHike > 0 ? '+' : ''}{item.dayPercentageHike.toFixed(1)}%
                                            </div>
                                        )}
                                    </div>
                                </td>
                                {/* <td style={dashboardStyles.td}>{item.lastWeek.toLocaleString()}</td> */}
                                <td style={dashboardStyles.td}>
                                    <div>
                                        <div>{item.lastWeek.toLocaleString()}</div>
                                        {item.weeklyPercentageHike !== null && (
                                            <div style={getPercentageStyle(item.weeklyPercentageHike)}>
                                                {item.weeklyPercentageHike > 0 ? '+' : ''}{item.weeklyPercentageHike.toFixed(1)}%
                                            </div>
                                        )}
                                    </div>
                                </td>
                                {/* <td style={dashboardStyles.td}>{item.lastMonth.toLocaleString()}</td> */}
                                <td style={dashboardStyles.td}>
                                    <div>
                                        <div>{item.lastMonth.toLocaleString()}</div>
                                        {item.monthlyPercentageHike !== null && (
                                            <div style={getPercentageStyle(item.monthlyPercentageHike)}>
                                                {item.monthlyPercentageHike > 0 ? '+' : ''}{item.monthlyPercentageHike.toFixed(1)}%
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td style={dashboardStyles.td}>
                                    <MixedWidget100
                                        className=""
                                        chartColor="primary"
                                        chartHeight="40px"
                                        title=""
                                        subtitle=""
                                        amount=""
                                        chartData={item.graphData}
                                        seriesName="Quantity"
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default WasteDashboard;